import React from "react";
import ReactDOM from "react-dom";
import Root from "./Root";

import "animate.css";

ReactDOM.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
  document.getElementById("root")
);
